import { useQuery } from 'react-query';

import { getCountryList } from '../api/getCountryList';
import { masterDataKeys, masterDataStaleTime } from '../api/queryKeys';

export const useCountryList = (params, { enabled = true } = {}) => {
  const { data, isLoading, isError, refetch } = useQuery(
    masterDataKeys.countries(params),
    () => getCountryList(params),
    {
      enabled,
      staleTime: masterDataStaleTime.BATCH,
      keepPreviousData: true,
    }
  );

  return { data, isLoading, isError, refetch };
};

export default useCountryList;
